import React, { useEffect, useState } from "react";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import { Calendar } from "lucide-react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import useClickOutside from "../../../../CustomHooks/useClickOutside";

const VisitHistoryDate = ({ label, name, value = "", onChange }) => {
  const [date, setDate] = useState(value);
  const [showDatePicker, serShowDatePicker] = useState(-1);
  const { dropdownRef } = useClickOutside(() => serShowDatePicker(-1));

  const handleShowDatePicker = () => {
    serShowDatePicker((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };

  useEffect(() => {
    setDate(value);
  }, [value]);

  const today = new Date();
  const currentYear = today.getFullYear();
  const disabledDays = (() => {
    const today = new Date();
    return {
      after: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // Disable future days but not today
    };
  })();
  return (
    <div>
      <div className="relative" ref={dropdownRef}>
        <div onClick={handleShowDatePicker} className="cursor-pointer">
          <label
            htmlFor="custom-calendar"
            className="text-[10px] lg:text-xs font-poppins absolute left-2 pr-2 py-1 top-1 lg:top-1 bg-white"
          >
            {date ? formatDate(date) : `Select ${label}`}
          </label>
          <Calendar
            color="gray"
            className="absolute right-1 top-[4px] w-3 lg:top-1 lg:w-4"
          />
          <input
            name={name}
            type="text"
            value={value}
            onChange={onChange}
            className={`w-full border text-[10px] lg:text-xs border-gray-400 rounded-md cursor-pointer py-[5px] lg:py-[7px] px-2 focus-input`}
          />
        </div>
        {showDatePicker === 1 && (
          <div className="shadow-sh-1 max-w-xs absolute left-0 top-12 bg-white z-9999">
            <DayPicker
              mode="single"
              captionLayout="dropdown"
              fromYear={2020}
              toYear={currentYear}
              selected={date}
              disabled={disabledDays}
              onSelect={(selectedDate) => {
                setDate(selectedDate);
                if (selectedDate) {
                       const formattedDate = [
                  selectedDate.getFullYear(),
                  String(selectedDate.getMonth() + 1).padStart(2, "0"),
                  String(selectedDate.getDate()).padStart(2, "0"),
                ].join("-");

                  onChange({
                    target: {
                      value: formattedDate,
                    },
                  });
                }
              }}
              classNames={{
                caption_label:
                  "font-bold font-poppins flex items-center mr-3 mb-2",
                head_row: "flex font-medium text-gray-900",
                head_cell: "w-7 font-normal text-sm",
                row: "flex w-full",
                cell: "text-gray-600 rounded-md h-7 w-7 text-center text-sm p-0",
                day: "h-7 w-7 p-0 font-normal",
                day_range_end: "day-range-end",
                day_selected:
                  "rounded-md text-white hover:bg-gray-900 hover:text-white focus:bg-gray-900 focus:text-white",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default VisitHistoryDate;
